module.exports = __webpack_public_path__ + "images/favicon.candidate.ico";


//////////////////
// WEBPACK FOOTER
// ./images/favicon.candidate.ico
// module id = 1111
// module chunks = 1